import React, { useRef, useState } from "react";
import styled from "@emotion/styled";
import { View, Image } from "react-native";
import { Dropdown } from ".";

interface IImageWithZoom {
  imagePath: any;
  showImg?: boolean;
  showImgLabel?: boolean;
  closeImg?: () => void;
}

export const ImageWithZoom = ({ imagePath, showImg = false, showImgLabel = true, closeImg }: IImageWithZoom) => {
  const imageRef = useRef(null);

  const [showTooltip, setShowTooltip] = useState(showImg);

  return (
    <View>
      {showImgLabel ? (
        <StyledImage onClick={() => setShowTooltip(true)} ref={imageRef} src={imagePath} alt="" />
      ) : (
        <></>
      )}

      <Dropdown
        onClose={() => {
          setShowTooltip(false);
          closeImg?.();
        }}
        show={showTooltip}
        parentRef={imageRef}
      >
        <Image source={imagePath} style={{ width: 400, height: 200 }} />
      </Dropdown>
    </View>
  );
};

const StyledImage = styled.img`
  width: 22px;
  height: 22px;
  border-radius: 5px;
  margin-right: 10px;
`;

export default ImageWithZoom;
